import React from 'react'
import ModelFormField from './ModelFormField'
import type { FormModel } from './ModelFormField'
import ModelDebug from './ModelDebug'
import cx from 'classnames'
import './Form.scss'

type FieldSpec = Record<string, unknown> & { name?: string }

type ModelFormProps = {
  fields?: FieldSpec[]
  className?: string
  model: FormModel
  pk?: unknown
  debug?: boolean
}

const ModelForm = ({
  fields = [],
  className,
  model,
  pk,
  debug = false,
}: ModelFormProps) => {
  return (
    <section className={cx('ModelForm', className)}>
      {fields.map(props => (
        <ModelFormField key={props.name} {...{ ...props, model, pk }} />
      ))}
      {debug && <ModelDebug {...{ model, pk }} />}
    </section>
  )
}

export default ModelForm
